import { useLocation, useParams } from 'react-router-dom';

import ClientsOverview from '../../features/clients/layouts/overview';
import ClientDetail from '../../features/clients/layouts/detail';
import ClientStats from '../../features/clients/layouts/stats';
import CreateClientForm from '../../features/clients/forms/create';
import EditClientForm from '../../features/clients/forms/edit';
import ClientLiquidation from '../../features/billing/layouts/client-liquidation';
import AccountStatement from '../../features/billing/layouts/account-statement';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
// /admin/clients · /admin/clients/new · /admin/clients/:id · /admin/clients/:id/edit
// 'new'/'edit' are detected from the path (not the :id param) so a static
// /new route and the dynamic /:id route never shadow each other.

export default function ClientsPage() {
    const { id } = useParams();
    const { pathname } = useLocation();

    if (pathname.endsWith('/new')) return <CreateClientForm />;
    if (id && pathname.endsWith('/edit')) return <EditClientForm clientId={id} />;
    if (id && pathname.endsWith('/stats')) return <ClientStats clientId={id} />;
    if (id && pathname.endsWith('/liquidation')) return <ClientLiquidation clientId={id} />;
    if (id && pathname.endsWith('/account')) return <AccountStatement clientId={id} />;
    if (id) return <ClientDetail clientId={id} />;
    return <ClientsOverview />;
}
